/// <amd-module name="Wit/Common/BacklogContent/ForecastingVelocityHeader" />
import * as React from "react";
import { ObservableValue, useObservable } from "VSS/Core/Observable";
import { CustomHeader } from "VSSUI/Header";
import { TextField, TextFieldStyle, TextFieldWidth } from "VSSUI/TextField";
import * as Resources from "Wit/Common/BacklogContent/Resources";
interface IForecastingHeaderProps {
    velocity: ObservableValue<number>;
    onVelocityUpdated: (velocity: number) => void;
}
export function ForecastingVelocityHeader(props: IForecastingHeaderProps) {
    const [velocity, setVelocity] = useObservable(props.velocity.value.toString());

    React.useEffect(() => {
        const onVelocityChange = (value: number) => {
            setVelocity(value.toString());
        };

        props.velocity.subscribe(onVelocityChange);
        return () => {
            props.velocity.unsubscribe(onVelocityChange);
        };
    }, [props.velocity]);

    return (
        <CustomHeader className="backlogs-forecast-header-row">
            <div className="flex-column justify-center flex-self-center">
                <span className="font-size-m">{Resources.ForecastingBasedOnVelocity}</span>
            </div>
            <TextField
                className="backlogs-forecast-header-row"
                inputType="number"
                value={velocity}
                onChange={(e, newValue) => {
                    setVelocity(newValue);
                    if (newValue) {
                        props.onVelocityUpdated(Number(newValue));
                    }
                }}
                style={TextFieldStyle.inline}
                width={TextFieldWidth.auto}
            />
        </CustomHeader>
    );
}
